import * as React from 'react'

const SvgSunLounge = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={219}
    height={120}
    viewBox="0 0 219 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#SunLounge_svg__a)">
      <path d="M73.977 0h-3.475v120h3.475V0Z" fill="#440A78" />
      <path
        d="M.005 34.239c10.26-14.734 38.726-25.333 72.24-25.333 33.512 0 61.973 10.594 72.238 25.333a84.998 84.998 0 0 0-38.42 0 258.821 258.821 0 0 0-67.633 0 84.998 84.998 0 0 0-38.42 0H.005Z"
        fill="#7130C9"
      />
      <path
        d="M.005 34.239a84.998 84.998 0 0 1 38.42 0C43.088 19.505 57.01 8.906 72.24 8.906 38.726 8.906 10.265 19.5 0 34.239h.005Z"
        fill="#440A78"
      />
      <path
        d="M144.79 34.239a84.998 84.998 0 0 0-38.42 0C101.707 19.505 87.785 8.906 72.556 8.906c33.513 0 61.974 10.594 72.239 25.333h-.005Z"
        fill="#E1CEFF"
      />
      <path
        d="M125.94 65.924a3.08 3.08 0 0 0-2.863-1.943H92.941l-.177-3.294-4.466 4.056a3.07 3.07 0 0 0-.835 3.45l13.969 35.115h39.374l-14.871-37.389.005.005Z"
        fill="#9865FC"
      />
      <path
        d="M145.189 99.324h-39.374L91.846 64.21c-.804-2.021.685-4.212 2.863-4.212h32.746a3.08 3.08 0 0 1 2.863 1.942l14.871 37.39v-.006Z"
        fill="#E1CEFF"
      />
      <path d="M170.802 99.324H87.251v5.88h83.551v-5.88Z" fill="#440A78" />
      <path d="M218.999 99.324h-48.197v5.88h48.197v-5.88Z" fill="#7130C9" />
      <path
        d="m208.595 105.204 5.669 14.791H219l-5.664-14.791h-4.741ZM172.545 105.204l5.664 14.791h4.736l-5.664-14.791h-4.736Z"
        fill="#AC94F0"
      />
      <path
        d="M99.03 119.995c4.088 0 7.402-3.31 7.402-7.393s-3.314-7.393-7.402-7.393-7.402 3.31-7.402 7.393 3.314 7.393 7.402 7.393Z"
        fill="#7130C9"
      />
      <path
        d="M139.489 119.995c4.088 0 7.402-3.31 7.402-7.393s-3.314-7.393-7.402-7.393-7.402 3.31-7.402 7.393 3.314 7.393 7.402 7.393Z"
        fill="#440A78"
      />
      <path
        d="M170.802 93.439h44.639a3.555 3.555 0 0 1 3.558 3.554v2.326h-48.197v-5.88Z"
        fill="#E1CEFF"
      />
      <path
        d="M170.802 99.324h-64.956l-2.36-5.885h67.316v5.885Z"
        fill="#7130C9"
      />
      <path
        d="M178.064 51.335c6.832 0 12.371-5.532 12.371-12.356s-5.539-12.356-12.371-12.356c-6.832 0-12.371 5.532-12.371 12.356s5.539 12.356 12.371 12.356Z"
        fill="#FFC103"
      />
    </g>
    <defs>
      <clipPath id="SunLounge_svg__a">
        <path fill="#fff" d="M0 0h219v120H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgSunLounge
